module.exports = __webpack_public_path__ + "img/0499e6_e58e4be1c2144faf9c8c1ae959721238_mv2.3c9ef906.webp";